import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { fetchAdminOrders, updateOrderStatus } from "../../api/admin";
import { euro } from "../../api/shop";

const STATUSES = ["pending", "confirmed", "shipped", "delivered", "cancelled"];
const STATUS_LABELS = {
  pending: "Pendiente",
  confirmed: "Confirmado",
  shipped: "Enviado",
  delivered: "Entregado",
  cancelled: "Cancelado",
};

export default function AdminOrders() {
  const { token } = useAuth();
  const [data, setData] = useState({ items: [], total: 0, pages: 1, page: 1 });
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    fetchAdminOrders({ page, status }, token)
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [page, status, token]);

  const changeStatus = async (order, newStatus) => {
    const previous = order.status;
    setData((d) => ({ ...d, items: d.items.map((o) => (o._id === order._id ? { ...o, status: newStatus } : o)) }));
    try {
      await updateOrderStatus(order._id, newStatus, token);
    } catch (err) {
      alert(err.message);
      setData((d) => ({ ...d, items: d.items.map((o) => (o._id === order._id ? { ...o, status: previous } : o)) }));
    }
  };

  return (
    <>
      <div className="admin__head">
        <div>
          <p className="eyebrow">Ventas</p>
          <h1 style={{ fontSize: "1.9rem" }}>Pedidos</h1>
        </div>
        <select
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            setPage(1);
          }}
        >
          <option value="">Todos los estados</option>
          {STATUSES.map((s) => (
            <option key={s} value={s}>
              {STATUS_LABELS[s]}
            </option>
          ))}
        </select>
      </div>

      {error && <div className="alert alert--error">{error}</div>}

      {loading ? (
        <div className="hero__skeleton" style={{ height: 300 }} />
      ) : data.items.length === 0 ? (
        <div className="state">
          <h3>No hay pedidos {status ? `con estado "${STATUS_LABELS[status]}"` : "todavía"}</h3>
        </div>
      ) : (
        <div className="orderlist">
          {data.items.map((order) => (
            <div className="ordercard" key={order._id}>
              <div className="ordercard__head">
                <div>
                  <p className="eyebrow">Pedido · {new Date(order.createdAt).toLocaleDateString("es-ES")}</p>
                  <p style={{ fontWeight: 700 }}>
                    {order.user?.name || "Cliente"} · {order.user?.email}
                  </p>
                </div>
                <select value={order.status} onChange={(e) => changeStatus(order, e.target.value)}>
                  {STATUSES.map((s) => (
                    <option key={s} value={s}>
                      {STATUS_LABELS[s]}
                    </option>
                  ))}
                </select>
              </div>

              {order.items.map((item, i) => (
                <div className="miniline" key={i}>
                  <span>
                    {item.quantity} × {item.title} <span className="eyebrow">{item.sku}</span>
                  </span>
                  <span>{euro(item.price * item.quantity)} €</span>
                </div>
              ))}

              <div className="summary__row" style={{ marginTop: 10, borderTop: "1px solid var(--line)" }}>
                <span>Total</span>
                <b>{euro(order.total)} €</b>
              </div>

              <p style={{ fontSize: "0.85rem", color: "var(--stone)", marginTop: 8 }}>
                Envío a: {order.address.street}, {order.address.city}, {order.address.state} {order.address.zip} · Tel:{" "}
                {order.address.phone}
              </p>
            </div>
          ))}
        </div>
      )}

      {data.pages > 1 && (
        <nav className="pager" aria-label="Paginación">
          <button className="btn btn--ghost" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
            Anterior
          </button>
          <span>
            {data.page} / {data.pages}
          </span>
          <button className="btn btn--ghost" disabled={page >= data.pages} onClick={() => setPage((p) => p + 1)}>
            Siguiente
          </button>
        </nav>
      )}
    </>
  );
}
